module FancyTree {
    export interface INodes {
        key: string,
        title: string
    }

    export class TreeSelect {
        private maxNodesToSelect: number = 0;

        private uid: string;
        private selectedNodes: INodes[];
        private divId: string
        private data: any;        

        constructor(id: string, data: any) {

            this.uid = (Math.random() + 1).toString(36).substring(2, 10);
            this.selectedNodes = new Array<INodes>();
            this.divId = id;
            this.data = data;
            this.BuildHtml();
            this.InitFancyTree();
            var uid = this.uid;

            $("#treeselect_treediv_" + uid).show();
        }        

        private BuildHtml() {
            $("#" + this.divId).html("<div id='treeselect_" + this.uid + "' class='treeselect' style='width:100%'>" +
               "<div id='treeselect_treediv_" + this.uid + "'>" +
                "<div id='treeselect_tree_" + this.uid + "' class='treeselect_tree'>" +
                "</div>" +
                "</div>");
        }

        private InitFancyTree(): void {
            var _this = this;
            $("#treeselect_tree_" + _this.uid).fancytree({
                extensions: ["glyph"],
                checkbox: true,
                icon: false,
                selectMode: 3, //'hier' = 'multi'
                generateIds: true, // Generate id attributes like <span id='fancytree-id-KEY'>
                glyph: {
                    preset: "awesome5"                    
                },
                source: _this.data,
                init: function (event, data) {
                    data.tree.visit(function (n) {
                    })
                },
                beforeSelect: function (event, data) {
                    if (_this.maxNodesToSelect > 0 && _this.GetSelectedNodes().length >= _this.maxNodesToSelect && !data.node.isSelected()) {
                        return false;
                    }
                },
                select: function (event, data) {
                    var selNodes = data.tree.getSelectedNodes();
                    _this.selectedNodes.length = 0;
                    $.map(selNodes, function (node) {
                        if (node.parent.key.indexOf("root") == -1) {
                            _this.selectedNodes.push({ key: node.parent.key, title: node.key });    
                        }                                            
                        return "";
                    });
                }
            });
        }

        public GetSelectedNodes(): { key: string, title: string }[] {
            return this.selectedNodes;
        }        

        public GetSelectedKeys(): string[] {
            var keys: string[] = new Array<string>();
            this.selectedNodes.forEach(function (node: { key: string, title: string }) {
                keys.push(node.key);
            });
            return keys;
        }

        public SelectNodes(enviroments: string[]) {
            for (var i = 0; i < enviroments.length; i++) {
                var node = $("#treeselect_tree_" + this.uid).fancytree("getTree").getNodeByKey(enviroments[i]);
                if (node) {
                    node.setSelected(true);
                }
            }
        }
    }

    export function RemoveNodeSelection(uid: string, key: string) {
        var node = $("#treeselect_tree_" + uid).fancytree('getTree').getNodeByKey(key);
        node.setSelected(false);
    }    
}